import {Component} from "react";
import request from "request-promise-native";
import Modal from "react-responsive-modal";
import Alert from "react-bootstrap/lib/Alert";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Button from "react-bootstrap/lib/Button";
import React from "react";

const REMOVE_CARD_ENDPOINT = "https://qibipay.azurewebsites.net/api/CardRemove";

class DeleteDeviceConfirmModal extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - card
             - open
             - onClose
             - onCardRemove
             - logout
        */
        super(props);
        this.state = {
            success: false
        };
    }

    async submit() {
        this.setState({loading: true, errorMessage:null});

        const card = this.props.card;

        const options = {
            method: 'POST',
            uri: REMOVE_CARD_ENDPOINT,
            body: {
                access_code: this.props.access_code,
                card_id: this.props.card.cardId
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        this.setState({loading: false});

        if(response.statusCode===404) {
            this.props.logout();
            return;
        }

        if(response.statusCode===400) {
            this.setState({errorMessage: response.body.msg});
            return;
        }

        if(response.statusCode!==200) {
            this.setState({errorMessage: 'Server error occured, please retry.'});
            return;
        }

        this.setState({
            success:true
        });

        //Success
        this.props.onCardRemove(card);
    }

    reset() {
        this.setState({
            success: false,
            loading: false,
            errorMessage: null
        });
        this.props.onClose();
    }

    render() {
        return (
            <Modal open={this.props.open} onClose={this.reset.bind(this)} styles={{
                modal: {
                }
            }} >
                <h2>Remove card</h2>

                {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                    <strong>{this.state.errorMessage}</strong>
                </Alert>) : ''}
                {this.state.loading ? (
                    <div>
                        <p>Removing card...</p>
                        <ProgressBar  active now={100}/>
                    </div>
                ) : this.state.success ? (
                    <div>
                        <p>Card removed successfully!</p>
                    </div>
                ) : (
                    <div>
                        <p>Do you really want to remove this card?</p>

                        <Button bsStyle="success" className='mr-2' disabled={this.state.loading} onClick={this.submit.bind(this)}>
                            Yes
                        </Button>

                        <Button bsStyle="danger" disabled={this.state.loading} onClick={this.reset.bind(this)}>
                            No
                        </Button>
                    </div>)}


            </Modal>
        );
    }
}

export default DeleteDeviceConfirmModal;